import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';
import { usePickupEtaRange } from '~/hooks/usePickupEtaRange';

import styles from './ProductPickupEta.module.scss';

/**
 * Estimated delivery dates to the customer's chosen pickup point (ПВЗ),
 * computed from the point's own `eta` (days) returned by the wms-connector.
 * Replaces the minute-based "Express" badge for external-pickup companies.
 */
const ProductPickupEta = () => {
  const { t } = useTranslation();
  const range = usePickupEtaRange();

  if (!range) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Icon type="standard-delivery" size={20} />
      <span>{t('pickupPointEta', { range })}</span>
    </div>
  );
};

export default observer(ProductPickupEta);
